import type { DocPageContent } from '../docs-content'

const page = {
  order: 11,
  slug: 'text-captions-subtitles',
  title: '文本、说明文字与字幕',
  description: '文本片段、转录稿、生成的说明文字、提示编辑和内嵌字幕。',
  category: '创意工具',
  sections: [
    {
      title: '文本片段',
      items: [
        '从"文本"标签页添加文本。',
        '选择单段或多段文本预设。',
        '调整字体、大小、颜色、对齐、背景、内边距、圆角和动画。',
      ],
    },
    {
      title: '说明文字',
      items: [
        '当需要语音文本时从媒体生成转录稿。',
        '从转录稿或 AI 说明文字工作流程创建说明文字。',
        '从属性面板编辑提示的开始、结束、内容和样式。',
        '应用说明文字样式预设以保持外观一致。',
      ],
    },
    {
      title: '内嵌字幕',
      items: [
        '扫描文件中的内嵌字幕轨道。',
        '从"内嵌字幕"对话框中选择一个字幕轨道。',
        '将可用提示插入时间线。',
        '在导出时，当容器格式支持时，将转录说明文字作为字幕轨道嵌入。',
      ],
    },
  ],
} satisfies DocPageContent

export default page